import styled from 'styled-components';
import { Breakpoints } from '../../styled/constants';

export const Section = styled.section<{ $setMargin?: boolean }>`
  background-color: ${({ theme }) => theme.colors.background.primary};
  color: ${({ theme }) => theme.colors.text.primary};
  padding: ${({ $setMargin }) => ($setMargin ? '70px 15px 15px' : '70px 15px')};
  max-width: calc(${Breakpoints.desktop}px + 30px);
  width: 100%;
  margin: 0 auto;

  @media (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    padding: ${({ $setMargin }) =>
      $setMargin ? '70px 40px 15px' : '70px 40px'};
    max-width: calc(${Breakpoints.desktop}px + 80px);
  }

  @media (min-width: ${({ theme }) => theme.smallDesktopBreakpoint}) {
    padding: ${({ $setMargin }) =>
      $setMargin ? '90px 40px 15px' : '90px 40px'};
    max-width: calc(${Breakpoints.desktop}px + 80px);
  }

  @media (min-width: ${({ theme }) => theme.desktopBreakpoint}) {
    padding: ${({ $setMargin }) =>
      $setMargin ? '90px 80px 15px' : '90px 80px'};
    max-width: calc(${Breakpoints.desktop}px + 160px);
  }
`;

export const BlackSection = styled(Section)`
  display: flex;
  flex-direction: column;
  gap: 90px;
  border-radius: 32px;
  background-color: ${({ theme }) => theme.colors.background.secondary};

  @media (min-width: ${({ theme }) => theme.smallDesktopBreakpoint}) {
    gap: 100px;
  }
`;

export const MapContainerStub = styled.div`
  height: 800px;
`;
